import { FETCH_SITE_ID_SUCCESS } from '../actions/fetch-site-id';

export const siteId = (state = null, action = {}) => {
  if (action.type === FETCH_SITE_ID_SUCCESS) {
    return action.payload;
  }
  return state;
};
